import React, { Component } from 'react';
import { Row, Col } from 'antd';

class index extends Component {
    render() {
        return (
            <div className="table7_1_1 style-center disclaimer">
                <Row className="title" id="table6_3">
                    <Row>1.1.4 Disclaimer 免责声明</Row>
                    <div
                        style={{
                            background: "#fff",
                            padding: "24px 0",
                            marginTop: 20
                        }}
                    >
                        <div style={{ padding: '0 24px' }}>
                            <div className='content_title'>Disclaimer</div>
                            <div className='content_text'>
                                <span className='em'> Performance Analysis</span>
                                has been prepared solely for general information purposes. The information on which it has been based has been derived from
                                <span className='em'>Executive Summary Report</span>
                                , which we believe to be reliable, but we have not independently verified such information and we do not guarantee its accuracy or completeness. All opinions and estimates included in
                                <span className='em'>Performance Analysis</span>
                                constitute our judgement as of the date of publication. They are subject to change without notice.
                                </div>
                            <div className='content_text'><span className='em'>Performance Analysis</span> base on confidentiality agreement, which with data masking. Your hotel data also under the confidentiality agreement and it is only visible to whom be granted access. <span className='em'>Performance Analysis</span> only provides the area average data for comparison.</div>
                            <div className='content_text'><span className='em'>Performance Analysis</span> is for internal use only, not for any performance appraisal or budget data. Transactions should not be entered into in reliance upon the information, opinions and estimates set out herein. We accept no responsibility to any person in any way in respect of any action taken or any failure to act in reliance upon the information contained herein.</div>
                        </div>
                        <div style={{ padding: '0 24px' }}>
                            <div className='content_title'>免责声明</div>
                            <div className='content_text'>《酒店经营情况分析》仅为集团酒店提供一般性统计参考而准备。本分析所依据的所有信息均来源于《月度经营报告》。我们相信报告中所填写的信息是真实的，但我们并未对这些信息进行逐项确认，因此也无法保证他们的真实性和完整性。涵盖在此分析中的所有判断和分析均来自分析发表前所获得的信息。</div>
                            <div className='content_text'>基于保密协议，《酒店经营情况分析》中我们已经将数据脱敏处理。您所在酒店的所有具体数值，仅由您酒店相关同事按不同权限可见，并且所有酒店也应遵守保密条款，不得擅自分享数据。针对各维度比较数据，我们仅提供脱敏处理后的区间平均值。</div>
                            <div className='content_text'>本数据仅供集团内部交流之用，不作为任何绩效考核和预算数据的依据。任何个人、单位以任何方式依据此统计的信息所进行的商业行为和资产交易、或者由于使用此统计数据造成的后果，我们不承担任何责任。未经大中華酒店（香港）有限公司书面许可，此分析的内容不得已任何形式复制、引用及转摘。</div>
                        </div>
                    </div>
                </Row>
            </div>
        )
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/performanceAnalysis/Disclaimer.js